import React, {useEffect} from 'react'
import Layout from '../../components/Layout/Layout'
import AdminUsers from "../../components/Admin/AdminUsers";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

const Admin = () => {
    const history = useNavigate();
    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;

    useEffect(() => {
        if (!userInfo) {
            history('/login?next=/dashboard');
        } else if (!userInfo?.isAdmin) {
            history('/dashboard');
        }
    }, [userInfo, history]);

    if(!userInfo || !userInfo?.isAdmin) {
        return null;
    }

  return (
    <Layout title={"Admin"} col>
      <AdminUsers />
    </Layout>
  )
}

export default Admin